import styled from "styled-components";

export const SectionIntro = styled.p`
  font-size: 18px;
  font-weight: 300;
  margin-bottom: 40px;
  line-height: 1.5;
`;
